var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M381.301 23.4707H130.701C71.4792 23.4707 23.4707 71.4792 23.4707 130.701V381.301C23.4707 440.522 71.4792 488.531 130.701 488.531H381.301C440.522 488.531 488.531 440.522 488.531 381.301V130.701C488.531 71.4792 440.522 23.4707 381.301 23.4707Z",
    fill: "url(#paint0_linear_5357_750)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M331 115.221C348.655 115.292 365.566 122.337 378.05 134.821C390.534 147.305 397.579 164.216 397.65 181.871V330.131C397.579 347.786 390.534 364.697 378.05 377.181C365.566 389.665 348.655 396.71 331 396.781H181C163.345 396.71 146.434 389.665 133.95 377.181C121.466 364.697 114.421 347.786 114.35 330.131V181.871C114.421 164.216 121.466 147.305 133.95 134.821C146.434 122.337 163.345 115.292 181 115.221H331ZM331 84.2209H181C127.29 84.2209 83.3398 128.221 83.3398 181.881V330.131C83.3398 383.841 127.34 427.791 181 427.791H331C384.71 427.791 428.66 383.791 428.66 330.131V181.871C428.66 128.161 384.71 84.2109 331 84.2109V84.2209Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 198.131C267.446 198.131 278.634 201.525 288.151 207.884C297.667 214.243 305.085 223.281 309.465 233.855C313.845 244.429 314.991 256.065 312.758 267.291C310.525 278.516 305.013 288.828 296.92 296.921C288.827 305.014 278.515 310.526 267.29 312.759C256.064 314.992 244.428 313.846 233.854 309.466C223.28 305.086 214.242 297.668 207.883 288.152C201.524 278.635 198.13 267.446 198.13 256.001C198.148 240.658 204.251 225.95 215.1 215.101C225.949 204.252 240.658 198.149 256 198.131ZM256 167.131C238.423 167.131 221.241 172.343 206.626 182.108C192.012 191.873 180.621 205.753 173.895 221.992C167.168 238.231 165.408 256.099 168.838 273.339C172.267 290.578 180.731 306.413 193.159 318.841C205.588 331.27 221.423 339.734 238.662 343.163C255.901 346.592 273.77 344.832 290.009 338.106C306.248 331.38 320.127 319.989 329.893 305.374C339.658 290.76 344.87 273.578 344.87 256.001C344.87 232.431 335.507 209.827 318.84 193.16C302.174 176.494 279.57 167.131 256 167.131Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M346.81 184.3C358.447 184.3 367.88 174.867 367.88 163.23C367.88 151.594 358.447 142.16 346.81 142.16C335.174 142.16 325.74 151.594 325.74 163.23C325.74 174.867 335.174 184.3 346.81 184.3Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5357_750",
    x1: 328.271,
    y1: 508.051,
    x2: 183.731,
    y2: 3.95068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDAD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FB832E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FA7321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F6692F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E84A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E03675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DD2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B43D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4D60D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4264DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.1056a5bd66eeee557101b66ed019110a.svg";
export { ForwardRef as ReactComponent };